<button mat-icon-button class="close-button" [mat-dialog-close]="true">
  <mat-icon class="close-icon" color="warn">close</mat-icon>
</button>
<div class="" fxLayout="column" fxLayoutAlign="center center">
  <mat-icon  style="color:#BBECFF;font-size: 80px;">error_outline</mat-icon>
  <table style="width:100%; margin-top:70px">
    <tr>
      <td align="center"><mat-icon align="center" >filter_1</mat-icon></td>
      <!-- <td align="center"><img src="assets/paso1.png" width="40px" alt="" ></td> -->
      <td align="right" class="texto">{{'WIZARD.LANDING.PRODUCTO.FOCUS_1.INST_MOD_FILTER_1' | translate}}</td>
    </tr>
    <tr style="margin-top:10px">
      <td align="center"><mat-icon align="center" >filter_2</mat-icon></td>
      <!-- <td align="center"><img src="assets/paso2.png" width="40px" alt="" ></td> -->
      <td align="right" class="texto">{{'WIZARD.LANDING.PRODUCTO.FOCUS_1.INST_MOD_FILTER_2' | translate}} </td>
    </tr>
  </table>
</div>
